import type { ErrorInfo } from 'react';

import MLALogger from './logger';

/**
 * `onError` for the design-system `ErrorBoundary` at the app root, around the routes and around each
 * protected page. React does not pass errors a boundary catches on to `window.onerror` in production,
 * so they never reach New Relic's browser agent on their own; report them ourselves to keep the
 * ChunkLoadError and render-failure groups visible (ENVDB-9411).
 */
export const reportBoundaryError = (error: Error, _info?: ErrorInfo): void => {
    MLALogger.Log(['ErrorBoundary'], error, 'error');
};
